import {useQuery} from 'react-query'
import {CategoryEditModalForm} from './CategoryEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getCategoriesFilter} from '../core/_requests'
import { CategoryStatus } from '../core/_models'

const CategoryEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const {
    isLoading,
    data: category,
    error,
    status
  } = useQuery(
    `${QUERIES.CATEGORIES_LIST}-category-${itemIdForUpdate}`,
    () => {
      return getCategoriesFilter({id: itemIdForUpdate, take: 0, skip: 1})
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <CategoryEditModalForm
        isCategoryLoading={isLoading}
        response={{
          status_id: CategoryStatus.active.id,
          created_at: new Date(),
        }}
        status={status}
      />
    )
  }

  if (!isLoading && !error && category) {
    return (
      <CategoryEditModalForm
      isCategoryLoading={isLoading}
        response={category?.data}
        status={status}
      />
    )
  }

  return null
}

export {CategoryEditModalFormWrapper}
